import { render } from "./DraggableTable.vue?vue&type=template&id=2385e0fc&scoped=true"
import script from "./DraggableTable.vue?vue&type=script&lang=js"
export * from "./DraggableTable.vue?vue&type=script&lang=js"

import "./DraggableTable.vue?vue&type=style&index=0&id=2385e0fc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2385e0fc"]])

export default __exports__